import FinMon from './views/fin-mon.c';
export default FinMon;
